import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { DashboardShell } from "@/components/dashboard/premium/DashboardShell";
import { ContentSkeleton } from "@/components/dashboard/premium/ContentSkeleton";
import { SessionMonitor } from "@/components/SessionMonitor";
import { PendingPaymentBanner } from "@/components/billing/PendingPaymentBanner";
import { useAuth } from "@/hooks/useAuth";
import { useBadgeNotifications } from "@/hooks/useBadgeNotifications";

/**
 * Persistent shell for every authenticated dashboard / admin / instructor page.
 *
 * Mounts ONCE for the entire authenticated session. React Router swaps only
 * the <Outlet /> below, so the sidebar, topbar, command palette, collapse
 * state, mobile sheet, notifications and user role query all persist across
 * navigation. No more full-page reload flicker when clicking sidebar items.
 */
export default function AppShellLayout() {
  const { user } = useAuth();
  useBadgeNotifications(user?.id);

  return (
    <DashboardShell>
      {/* Session monitor lives at the shell so it doesn't remount per page */}
      <SessionMonitor isAdminRoute={false} />
      <PendingPaymentBanner />
      <Suspense fallback={<ContentSkeleton />}>
        <Outlet />
      </Suspense>
    </DashboardShell>
  );
}

